import service from '@src/assets/js/api_upload.js'
import Axios from "axios";
let bucket = 'huiyi-pro';
if (process && process.env && process.env.NODE_ENV === 'development') {
    bucket = 'huiyi-test'
}
if (process && process.env && process.env.NODE_ENV === 'test') {
    bucket = 'huiyi-test'
}
if (process && process.env && process.env.NODE_ENV === 'LOCAL') {
    bucket = 'huiyi-test'
}
const state = {
    bucket: bucket,
    OSSInfo: "",
}
const actions = {
    async getSTS({ commit }, params) {
        console.log(params);
        let result = await service.requestAjax({
            method: 'POST',
            url: `/aliyunSTSController/getAliyunSTS?fileNameUrl=${params.fileNameUrl}&fileNames=${params.fileNames}&bucketName=${params.bucketName}`,
            headers: {
                'jwt': localStorage.getItem('jwt'),
            },
        })
        return result
    },
    async getSTSURL({ commit }, params) {
        console.log(params);
        let result = await service.requestAjax({
            method: 'POST',
            url: `/aliyunSTSController/getStsUrl?fileNameUrl=${params.fileNameUrl}&fileNames=${params.fileNames}&bucketName=${params.bucketName}`,
            headers: {
                'jwt': localStorage.getItem('jwt'),
            },
        })
        return result
    },
    // 上传图片1
    async put({ state, dispatch }, options) {
        console.log(options)
        var name_date = options.file.name.split('.')[0] + Date.now() + '.' + options.file.name.split('.')[1]
        var objName = options.objName + name_date
        let params = {
            fileNameUrl: options.objName,
            bucketName: bucket,
        }
        console.log(objName);
        let result = await dispatch('getSTS', params)
        console.log(result);
        let data = result.data.retValue
        var formData = new FormData();
        formData.append("OSSAccessKeyId", data.accessid);
        formData.append("signature", data.signature);
        formData.append("policy", data.policy);
        formData.append("key", objName);//注意顺序，file要在key的后面。不然会返回找不到key 的错误
        formData.append("file", options.file);
        formData.append("success_action_status", 200);
        console.log(formData);
        let res = await Axios({
            method: 'POST',
            url: data.host,
            data: formData,
        })
        return { name: objName,bucketName: bucket }
    },
    async getBucketACL({ commit }, options) {
        let result = await service.requestAjax({
            method: 'POST',
            url: 'uploadFileController/getPostPolicy',
            headers: {
                'jwt': localStorage.getItem('jwt')
            },
        })
        return result
    },
    async getBucketACLPublic({ commit }, options) {
        let result = await service.requestAjax({
            method: 'POST',
            url: 'uploadFileController/getPostPolicyPublic',
            headers: {
                'jwt': localStorage.getItem('jwt')
            },
        })
        return result
    },
    // 获取图片
    // arr=['./image/2012596325.jpg','',...]
    async getPicture({ state, dispatch }, options) {
        var arr = options.url
        for (var i = 0; i < arr.length; i++) {
            var obj = arr[i]
            let res = await dispatch('getSTSURL', {fileNames: obj, bucketName: bucket})
            arr[i] = res.data.retValue[0]
        }
        return arr
    }
}
const mutations = {
    changeSTS(state, val) {
        state.OSSInfo = val.data.retValue
    }
}
export default {
    state, actions, mutations
}
